import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const Terms = () => <LegalPageLayout namespace="terms" sectionCount={10} />;

export default Terms;
